import { Typography, Row, Col, Card } from 'antd';
import React from 'react';
import {
    YoutubeFilled,
    CustomerServiceOutlined,
    SmileOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
const { Title, Paragraph, Text } = Typography;
const OldHome = () => {
    const navigate = useNavigate();
    return (
        <Row gutter={[32, 32]} justify="center">
            <Col lg={12} md={12} sm={24} xs={24}>
                <Row justify={"center"} >
                    <Col span={"auto"}>
                        <Title level={1}>關於計畫</Title>
                    </Col>
                </Row>
                <Row gutter={[8, 8]}>
                    <Col span={"auto"}>
                        <Title level={3}>計畫源起</Title>
                    </Col>
                    <Col span={24} >
                        <Paragraph >
                            國家競爭力源自於教育力，教育力的根本在語文教育，舉凡閱讀、理解、思維、表達、均取決於語文教育。經典誦讀不僅是語文思想的教育，更是品格文化素養的教育，在分心的時代更是專注力培育的最佳途徑。林岱樺立委深感於此，特針對高雄地區國小如何強化語文教育及文化傳承之必要召開會議，確立以經典教育落實品格養成，扎實語文根柢。
                        </Paragraph>
                        <Paragraph>
                            本計畫以推廣經典朗讀為核心，編撰語文補充教材以銜接中學國文課程，以楊定一醫學博士之醫學論證為基礎，強調琅琅讀經聲自有其定靜心神腦波、強化智慧的功效，藉以童蒙養正奠定人文素養。故本計畫特以推廣經典朗讀為核心的語文補充教材以銜接中學國文課程，藉以奠定全民人文素養之根基。
                        </Paragraph>
                    </Col>
                    <Col span={"auto"}>
                        <Title level={3}>計畫目標</Title>
                    </Col>
                    <Col span={24} >
                        <Row>
                            <Col span={24}>
                                <Text>
                                    一、積極強化落實國小語文經典教育扎根。
                                </Text>
                                <br />
                                <br />
                                <Text>
                                    二、編纂國小語文經典教材及有聲書。
                                </Text>
                                <br />
                                <br />
                                <Text>
                                    三、建立經典教育推展工作支持系統。
                                    <ul style={{ listStyleType: 'none' }}>
                                        <li>
                                            <ol type='1'>
                                                <li>辦理種子教師培訓。</li>
                                                <li>研發教法。</li>
                                                <li>建置群科諮詢輔導機制,推動種子教師社群。</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </Text>
                                <Text>
                                    四、辦理經典朗讀節等各項推廣教育活動。
                                </Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
                <Row gutter={[8, 32]}>
                    <Col span={24}>
                        <Row justify={"center"} >
                            <Col span={"auto"}>
                                <Title level={1}>活動影片</Title>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <iframe
                            width="100%"
                            height="350px"
                            src="https://www.youtube.com/embed/M-oEnXuAlZ8?si=s6HRPPzRa4sre2aQ" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                    </Col>
                    <Col span={24}>
                        <iframe
                            width="100%"
                            height="350px"
                            src="https://www.youtube.com/embed/54UbJDwrw4s"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                    </Col>
                    <Col span={24}>
                        <Card
                            style={{
                                cursor: "pointer"
                            }} >
                            <Card.Grid
                                onClick={() => { window.open("https://www.youtube.com/channel/UCxwW57nnSQH1cnSXiHzWcrw") }}
                            >
                                <Row>
                                    <Col span={24}>
                                        <YoutubeFilled style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>訂閱 Youtube</Title>
                                        <Text >觀看更多朗讀節影片</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                            <Card.Grid onClick={() => { window.open("https://linktr.ee/poemlion") }}>
                                <Row>
                                    <Col span={24}>
                                        <CustomerServiceOutlined style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>聆聽 Podcast</Title>
                                        <Text > 收聽更多經典文學</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                            <Card.Grid onClick={() => { navigate("/poetry_reading") }}>
                                <Row>
                                    <Col span={24}>
                                        <SmileOutlined style={{ fontSize: '50px', color: "red" }} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>前往詩詞朗讀</Title>
                                        <Text > 跟著音檔一起讀</Text>
                                    </Col>
                                </Row>
                            </Card.Grid>
                        </Card>
                    </Col>
                </Row>
            </Col >
        </Row >
    )
};
export default OldHome;